import { render, staticRenderFns } from "./RitualCircleList.vue?vue&type=template&id=232541e4"
import script from "./RitualCircleList.vue?vue&type=script&lang=js"
export * from "./RitualCircleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('232541e4')) {
      api.createRecord('232541e4', component.options)
    } else {
      api.reload('232541e4', component.options)
    }
    module.hot.accept("./RitualCircleList.vue?vue&type=template&id=232541e4", function () {
      api.rerender('232541e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ritualCircles/RitualCircleList.vue"
export default component.exports